module.exports = __webpack_public_path__ + "608f4b8d11ba1eb82b88fb6736f9173f.svg";